module.exports = __webpack_public_path__ + "static/media/Popup_framing@3x.de84797e.png";